import debounce from "lodash/debounce";
import React, { useCallback, useEffect, useState } from "react";
import SidebarMenuListInner from "./sidebarMenuList.inner";
export default function SidebarMenuList({ filterText, ...other }) {
    const [filterTextDebounced, setFilterTextDebounced] = useState(filterText);
    const filterChangedCallback = useCallback(debounce((text) => {
        setFilterTextDebounced(text);
    }, 400), []);
    useEffect(() => {
        filterChangedCallback(filterText);
    }, [filterText]);
    return React.createElement(SidebarMenuListInner, { filterText: filterTextDebounced, ...other });
}
SidebarMenuList.defaultProps = {
    bgColorDefault: "navbar-bg",
    colorDefault: "navbar-link-color",
    colorHover: "navbar-link-hover-color",
    colorActive: "navbar-link-active-color",
    bgColorHover: "navbar-bg-item-hover",
    bgColorActive: "navbar-bg-lighter",
    actionIconColor: "navbar-icon-active",
    hasOutsideIndents: true
};
